/**
 * 调试面板 Socket 连接控制模块。
 */

import { SIGNAL_SERVER_URL } from "@/services/remote/config";
import { useSocketStore } from "@/services/remote/socket";
import { useConnectionStore } from "@/stores/remote";

type ConnectionManagerProps = {
	isConnected: boolean;
};

/**
 * 调试面板中的 Socket 连接控制组件。
 * @param {ConnectionManagerProps} props 组件参数
 */
export function ConnectionManager({ isConnected }: ConnectionManagerProps) {
	const { connect, disconnect } = useSocketStore();
	const { startHeartbeat, stopHeartbeat } = useConnectionStore();

	return (
		<div className="flex flex-row gap-2">
			<div>
				Socket Status:{" "}
				<div className={`badge   ${isConnected ? "badge-primary" : " "}  `}>
					{isConnected ? "connected " : "disconnected"}
				</div>
				- {SIGNAL_SERVER_URL}
			</div>

			<div>
				<button
					type="button"
					className="btn btn-sm btn-primary mr-2"
					onClick={connect}
				>
					Connect
				</button>
				<button
					type="button"
					className="btn btn-sm btn-danger"
					onClick={disconnect}
				>
					Disconnect
				</button>

				<button
					type="button"
					className="btn btn-sm btn-primary"
					onClick={startHeartbeat}
				>
					Start Heart
				</button>
				<button
					type="button"
					className="btn btn-sm btn-primary"
					onClick={stopHeartbeat}
				>
					Stop Heart
				</button>
			</div>
		</div>
	);
}
